import { Box, Typography } from '@material-ui/core';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import AddButton from 'common/components/buttons/addButton';
import { InputLabelOutlined } from 'common/components/fields/fields';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import LoadingProgress from 'common/components/progress/loading';
import Table6 from 'common/components/table/table6';
import { tableSearch } from 'helpers/utils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getList, remove } from './lottiesActions';

export function Lotties(props) {
  const { router } = props;
  const { list, loading } = props.lotties;

  const [columns] = useState([
    { field: 'name', title: 'Nome:' },
    { field: 'createdAt', title: 'Criado em:' },
  ]);
  const [data, setData] = useState([]);
  const [value, setValue] = useState('');

  useEffect(() => {
    props.getList();
  }, []);

  useEffect(() => {
    setData(props.lotties.list.content);
  }, [props.lotties.list.content]);

  function handleChange(e) {
    setData(tableSearch(e, props.lotties.list.content));
    setValue(e.target.value);
  }

  function handleDelete(id, resolve, reject) {
    props.remove(id, resolve, reject);
  }

  function onRowClick(e, rowData) {
    router.push(`/admin/lotties/${rowData.id}/editar`);
  }

  function renderEmptyScreen() {
    return (
      <section
        id="statement-buy-points"
        style={{ marginTop: '4.3em', height: '100vh' }}
      >
        <GeneralGrid container spacing={3} alignItems="center">
          <GeneralGrid item xs={12} md={6}>
            <GeneralGrid container spacing={3}>
              <GeneralGrid item xs={12}>
                <h2 className="signup-text">
                  Você ainda não criou nenhuma lottie
                </h2>
              </GeneralGrid>
            </GeneralGrid>
          </GeneralGrid>
          <GeneralGrid item xs={12} md={6}>
            <img
              src={placeholder_illustration}
              className="img-fluid"
              alt="Ilustração: não há dados"
            />
          </GeneralGrid>
        </GeneralGrid>
      </section>
    );
  }

  if (loading) {
    return (
      <Box display="flex" height="100vh" justifyContent="center" mt={7}>
        <LoadingProgress />
      </Box>
    );
  }

  if (list.content.length < 1) {
    return renderEmptyScreen();
  }

  return (
    <section id="lotties">
      <GeneralGrid container spacing={3}>
        <GeneralGrid item xs={12}>
          <GeneralGrid
            container
            spacing={3}
            justify="space-between"
            alignContent="space-between"
          >
            <GeneralGrid item xs={3}>
              <span
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: 500,
                  fontSize: 24,
                }}
              >
                Animações
              </span>
              <Typography variant="body1" style={{ marginTop: 20 }}>
                {props.lotties.list.content.length} animações
              </Typography>
            </GeneralGrid>
            <GeneralGrid item xs={3}>
              <InputLabelOutlined
                input={{ onChange: handleChange, value: value }}
                meta={{}}
                onChange={handleChange}
                value={value}
                label="Procurar"
                name="search"
                margin="normal"
              />
            </GeneralGrid>
          </GeneralGrid>
          <GeneralGrid container spacing={3}>
            <GeneralGrid item xs={12}>
              <Table6
                title="Lotties"
                columns={columns}
                data={data}
                router={router}
                remove
                handleDelete={handleDelete}
                onRowClick={onRowClick}
              />
            </GeneralGrid>
          </GeneralGrid>
        </GeneralGrid>
      </GeneralGrid>

      <AddButton onClick={() => props.router.push('/admin/lotties/novo')} />
    </section>
  );
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    lotties: state.lotties,
  };
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getList,
      remove,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Lotties);
